import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export interface IConfigureUpdateMenuRangesRequest {
  ranges: string[];
}

export interface IConfigureUpdateMenuRangesResponse {
  type: string;
  data: {
    ranges: string[];
  };
}

export const updateMenuRanges = async (
  menuId: string,
  payload: IConfigureUpdateMenuRangesRequest,
): Promise<Response> => {
  const res = await fetch(`${API_URL}/menus/${menuId}/ranges`, {
    method: 'PUT',
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    throw new Error('Something went wrong whilst updating the menu ranges');
  }

  return res;
};
